/**
 * KARVA Messung (2026-10)
 * Meldet Schritte im Konfigurator als Shopify-Kundenereignisse ("karva_…").
 * Das benutzerdefinierte Pixel "KARVA Messung" (Shopify > Einstellungen > Kundenereignisse)
 * schickt sie zusammen mit Seitenaufrufen, Warenkorb und Kauf in das Google Sheet "KARVA Messung".
 * Keine personenbezogenen Daten: nur Schritt, Größe, Preis, Ansicht.
 */
(function () {
  'use strict';
  if (window.__karvaTracking) return;
  window.__karvaTracking = true;

  var state = { foto: false, vorschau: false, warenkorb: false, start: Date.now(), groesse: null, preis: null, ansichten: {} };

  function send(name, data) {
    data = data || {};
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('karva_' + name, data);
      }
    } catch (e) { /* Messung darf nie stören */ }
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'karva_' + name, karva: data }); } catch (e) {}
  }

  function byId(id) { return document.getElementById(id); }
  function num(v) { var n = parseFloat(String(v || '').replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '')); return isNaN(n) ? null : n; }
  function size() {
    var w = parseFloat((byId('custom-width') || {}).value), h = parseFloat((byId('custom-height') || {}).value);
    return (w > 0 && h > 0) ? w + 'x' + h : null;
  }
  function price() { var p = byId('halftone-price-display'); return p ? num(p.textContent) : null; }
  function hasImage() { return !!document.querySelector('.halftone-image-placeholder.has-image'); }
  function secs() { return Math.round((Date.now() - state.start) / 1000); }

  // 1. Foto ausgewählt
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.id === 'source_file' && t.files && t.files.length) {
      var f = t.files[0];
      state.foto = true;
      send('foto_hochgeladen', { typ: (f.type || '').replace('image/', ''), mb: Math.round(f.size / 1e5) / 10, sekunden: secs() });
    }
  }, true);

  // Klicks im Konfigurator (Elemente entstehen dynamisch, daher Delegation)
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var b;
    if ((b = t.closest('#karva-view-toggle button[data-view]'))) {
      var v = b.getAttribute('data-view');
      state.ansichten[v] = true;
      send('ansicht_gewechselt', { ansicht: v, groesse: size() });
    } else if ((b = t.closest('.karva-size-preset'))) {
      send('schnellwahl_groesse', { groesse: b.getAttribute('data-w') + 'x' + b.getAttribute('data-h') });
    } else if (t.closest('.karva-tier-hint__link')) {
      send('gleicher_preis_groesser', { von: size() });
    } else if (t.closest('#karva-zoom-btn')) {
      send('zoom_geoeffnet', { groesse: size() });
    } else if (t.closest('#karva-help-wa')) {
      send('beratung_whatsapp', { groesse: size(), vorschau: hasImage() });
    } else if ((b = t.closest('#karva-help a'))) {
      send('beratung_kontakt', { groesse: size(), vorschau: hasImage() });
    }
  }, true);

  // 2. Vorschau fertig, 3. Größe/Preis geändert
  var sizeTimer = null;
  function watch() {
    var ph = document.querySelector('.halftone-image-placeholder');
    var pr = byId('halftone-price-display');
    if (!ph || !pr) { setTimeout(watch, 500); return; }
    new MutationObserver(function () {
      if (hasImage() && !state.vorschau) {
        state.vorschau = true;
        send('vorschau_fertig', { groesse: size(), preis: price(), sekunden: secs() });
      }
    }).observe(ph, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function () {
      clearTimeout(sizeTimer);
      sizeTimer = setTimeout(function () {
        if (!hasImage()) return;
        var s = size(), p = price();
        if (!s || s === state.groesse) return;
        var first = state.groesse === null;
        state.groesse = s; state.preis = p;
        if (!first) send('groesse_geaendert', { groesse: s, preis: p });
      }, 1500);
    }).observe(pr, { childList: true, characterData: true, subtree: true });
  }
  watch();

  // 4. Konfiguriertes Bild in den Warenkorb
  var orig = window.fetch;
  if (typeof orig === 'function') {
    window.fetch = function (input, init) {
      var p = orig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof FormData !== 'undefined' &&
            init.body instanceof FormData && init.body.has('properties[_Render-Settings]')) {
          var opt = byId('karva-optimize'), soc = byId('karva-social'), mnt = byId('karva-mount');
          var data = {
            groesse: size(), preis: price(), sekunden: secs(),
            optimieren: !opt || opt.checked,
            social: !!(soc && soc.checked),
            halterung: !!(mnt && mnt.checked),
            ansichten: Object.keys(state.ansichten).join(',')
          };
          p.then(function (res) { if (res && res.ok) { state.warenkorb = true; send('in_warenkorb', data); } }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  // 5. Abbruch: Vorschau gesehen, aber nichts in den Warenkorb gelegt
  var sentExit = false;
  function exit() {
    if (sentExit || !state.vorschau || state.warenkorb) return;
    sentExit = true;
    send('abbruch_nach_vorschau', { groesse: state.groesse || size(), preis: state.preis || price(), sekunden: secs(), ansichten: Object.keys(state.ansichten).join(',') });
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') exit(); });
  window.addEventListener('pagehide', exit);
})();
